import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bepatient-change-email-popup',
  templateUrl: './change-email-popup.component.html',
  styleUrls: ['./change-email-popup.component.scss'],
  standalone: false
})
export class ChangeEmailPopupComponent {
  @Input() color: string;
  @Input() message: string;
  @Input() buttonLabel: string;
  @Input() isSuccess: boolean;
  @Output() validated = new EventEmitter<boolean>();
}
